import { render } from "./DigitalClock.vue?vue&type=template&id=b1e70870&scoped=true"
import script from "./DigitalClock.vue?vue&type=script&lang=js"
export * from "./DigitalClock.vue?vue&type=script&lang=js"

import "./DigitalClock.vue?vue&type=style&index=0&id=b1e70870&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e70870"]])

export default __exports__